"use client";

import { useCallback } from "react";
import { MODAL_IDS, useGlobalModalStack } from "@wtc/ui";
import {
  buildComposeModalDataFromContext,
  buildSendTextModalDataFromContext,
  type ContactMethodEntityContext,
} from "@/lib/utils/crm/contact-method-context";

export function useOpenContactMethodModals() {
  const { openModal } = useGlobalModalStack();

  const openEmail = useCallback(
    (email: string, context?: ContactMethodEntityContext) => {
      openModal(
        MODAL_IDS.messages.compose,
        buildComposeModalDataFromContext(email, context)
      );
    },
    [openModal]
  );

  const openText = useCallback(
    (phone: string, context?: ContactMethodEntityContext) => {
      openModal(
        MODAL_IDS.messages.sendText,
        buildSendTextModalDataFromContext(phone, context)
      );
    },
    [openModal]
  );

  return { openEmail, openText };
}
